import { Mail } from "lucide-react";
import ContactForm from "@/components/landing/ContactForm";

export const ContactSection = () => (
  <section id="contact" className="py-24 bg-[#0B0B0F] text-white">
    <div className="max-w-[1120px] mx-auto px-6 grid lg:grid-cols-2 gap-12 items-start">
      <div>
        <span className="inline-flex text-xs font-bold uppercase tracking-[0.2em] text-[#F58220]">Contact us</span>
        <h2 className="mt-4 text-3xl sm:text-4xl font-bold tracking-tight leading-snug">
          Start your DPDP readiness journey today.
        </h2>
        <p className="mt-4 text-base md:text-lg text-white/60 leading-relaxed max-w-[500px]">
          Tell us a little about your organisation and we'll set up a conversation about your DPDP roadmap, from mindset
          change to independent certification.
        </p>
        <a
          href="mailto:partnerships@dhwaniris.com"
          data-testid="contact-email-link"
          className="mt-8 inline-flex items-center gap-2.5 text-[15px] font-semibold text-white hover:text-[#F58220] transition-colors"
        >
          <span className="w-10 h-10 rounded-[10px] bg-white/10 grid place-items-center"><Mail size={18} /></span>
          partnerships@dhwaniris.com
        </a>
      </div>
      <div className="rounded-[14px] bg-white text-[#0B0B0F] p-8 lg:p-10 shadow-[0_24px_48px_-12px_rgba(0,0,0,0.4)]">
        <h3 className="text-xl font-semibold mb-6">Reach out to us</h3>
        <ContactForm idPrefix="contact-section" />
      </div>
    </div>
  </section>
);

export default ContactSection;
